import React from "react";

export function Background() {
  return (
    <>
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_10%,rgba(59,130,246,0.26),transparent_45%),radial-gradient(circle_at_75%_0%,rgba(168,85,247,0.22),transparent_45%),radial-gradient(circle_at_50%_75%,rgba(34,211,238,0.12),transparent_55%)]" />
        <div className="absolute inset-0 opacity-25 [background-image:radial-gradient(rgba(255,255,255,0.55)_1px,transparent_1px)] [background-size:18px_18px]" />
        <div className="absolute -top-48 right-[-180px] h-[520px] w-[920px] opacity-35 blur-3xl [background:conic-gradient(from_180deg,rgba(34,211,238,0.35),rgba(59,130,246,0.25),rgba(168,85,247,0.22),rgba(34,211,238,0.35))]" />
        <div className="absolute left-[-220px] top-[140px] h-[480px] w-[720px] opacity-30 blur-3xl [background:radial-gradient(circle_at_40%_40%,rgba(59,130,246,0.28),transparent_55%)]" />
      </div>

      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_10%,transparent_20%,rgba(0,0,0,0.45)_78%,rgba(0,0,0,0.68)_100%)]" />
    </>
  );
}
